// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"9c9271a9","513":"3363548e","703":"80fcb998","787":"28cb0dcd"}[chunkId] + ".chunk.js";
};